import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { S } from "@/pages/ibloom/styles";

const STEPS = [
  { n: "1", t: "Shop from local shops", d: "Browse real products with live stock from neighbourhood shops on the map, and order from home." },
  { n: "2", t: "Pay online (prepaid)", d: "Every prepaid order earns HealthCoins worth 1% of your spend. 1 HealthCoin = ₹1." },
  { n: "3", t: "Fund your insurance", d: "Redeem HealthCoins toward your family's health-insurance premium — up to ₹20,000 per policy." },
];

const FAQS = [
  { q: "How do I earn HealthCoins?", a: "You earn HealthCoins worth 1% of the order value on every prepaid order. Coins are credited once your order is delivered. 1 HealthCoin equals ₹1." },
  { q: "How much can I save?", a: "You can redeem up to ₹20,000 per policy toward your health-insurance premium. The more you shop local, the more you save." },
  { q: "Do cash-on-delivery orders earn HealthCoins?", a: "HealthCoins are earned on prepaid orders only. COD orders don't earn insurance savings — this keeps the programme fair and fraud-free." },
  { q: "Can I use HealthCoins for anything else?", a: "Yes — besides your insurance premium, you can also redeem coins for free family health checks at home. Just ask us on WhatsApp." },
];

export default function HealthInsuranceLanding() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Health Insurance Savings — Earn ₹ Toward Your Premium While You Shop | MapBazzar";
  }, []);

  return (
    <div data-testid="health-insurance-landing" style={{ minHeight: "100vh", background: "#FBF9F3", color: "#1A1A1A", fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      {/* Hero */}
      <header style={{ background: "linear-gradient(135deg,#0F3D2E,#1C6B4A)", color: "white", padding: "64px 22px 72px", textAlign: "center" }}>
        <div style={{ maxWidth: 820, margin: "0 auto" }}>
          <div style={{ display: "inline-block", background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.25)", borderRadius: 100, padding: "6px 14px", fontSize: 12, fontWeight: 700, letterSpacing: 1, marginBottom: 20 }}>
            🛡️ SHOP → HEALTH INSURANCE SAVINGS
          </div>
          <h1 style={{ ...S.fraunces, fontSize: "clamp(32px, 5.4vw, 58px)", fontWeight: 800, lineHeight: 1.06, letterSpacing: "-1.4px", margin: "0 0 18px" }}>
            Turn everyday shopping into<br />
            <span style={{ color: "#FFD54A" }}>health-insurance savings.</span>
          </h1>
          <p style={{ fontSize: "clamp(15px, 2vw, 18px)", lineHeight: 1.65, opacity: 0.92, maxWidth: 700, margin: "0 auto 30px" }}>
            MapBazzar is the only shopping app that pays you back in health protection. Shop from real local shops near you, and every prepaid order earns ₹ toward your family's health-insurance premium — <strong>something no other app gives you</strong>.
          </p>
          <button data-testid="hi-start-shopping" onClick={() => navigate("/app")} style={{ padding: "15px 30px", borderRadius: 100, border: "none", background: "#FFD54A", color: "#0F3D2E", fontWeight: 800, fontSize: 16, cursor: "pointer", boxShadow: "0 12px 28px rgba(0,0,0,0.25)" }}>
            🛍️ Start Shopping &amp; Saving
          </button>
        </div>
      </header>

      {/* How it works */}
      <section style={{ maxWidth: 960, margin: "0 auto", padding: "56px 22px 20px" }}>
        <h2 style={{ ...S.fraunces, fontSize: "clamp(24px, 3.4vw, 34px)", fontWeight: 800, textAlign: "center", color: "#0F3D2E", margin: "0 0 36px" }}>How shopping funds your health insurance</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 18 }}>
          {STEPS.map((s) => (
            <div key={s.n} style={{ background: "white", borderRadius: 18, padding: "26px 22px", border: "1px solid #EAE6DA", boxShadow: "0 8px 22px rgba(0,0,0,0.05)" }}>
              <div style={{ width: 40, height: 40, borderRadius: "50%", background: "#0F3D2E", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 18, marginBottom: 14 }}>{s.n}</div>
              <h3 style={{ fontSize: 17, fontWeight: 800, color: "#0F3D2E", margin: "0 0 8px" }}>{s.t}</h3>
              <p style={{ fontSize: 14, lineHeight: 1.6, color: "#555", margin: 0 }}>{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Value band */}
      <section style={{ maxWidth: 820, margin: "0 auto", padding: "34px 22px" }}>
        <div style={{ background: "#F1F8F4", border: "1px solid #D8ECE0", borderRadius: 20, padding: "30px 26px", textAlign: "center" }}>
          <div style={{ ...S.fraunces, fontSize: 40, fontWeight: 800, color: "#0F3D2E" }}>1% back on every order</div>
          <p style={{ fontSize: 15, color: "#0F3D2E", lineHeight: 1.6, marginTop: 10, marginBottom: 0 }}>
            1 HealthCoin = ₹1 off your health-insurance premium. Save up to <strong>₹20,000 per policy</strong> — plus redeem coins for free family health checks at home.
          </p>
        </div>
      </section>

      {/* FAQ (rich, indexable) */}
      <section style={{ maxWidth: 820, margin: "0 auto", padding: "20px 22px 60px" }}>
        <h2 style={{ ...S.fraunces, fontSize: "clamp(22px, 3vw, 30px)", fontWeight: 800, textAlign: "center", color: "#0F3D2E", margin: "0 0 28px" }}>Frequently asked questions</h2>
        {FAQS.map((f, i) => (
          <div key={i} style={{ background: "white", borderRadius: 14, padding: "18px 20px", border: "1px solid #EAE6DA", marginBottom: 12 }}>
            <h3 style={{ fontSize: 15.5, fontWeight: 800, color: "#1A1A1A", margin: "0 0 6px" }}>{f.q}</h3>
            <p style={{ fontSize: 14, lineHeight: 1.6, color: "#555", margin: 0 }}>{f.a}</p>
          </div>
        ))}
        <div style={{ textAlign: "center", marginTop: 34 }}>
          <button data-testid="hi-start-shopping-2" onClick={() => navigate("/app")} style={{ padding: "15px 30px", borderRadius: 100, border: "none", background: "linear-gradient(135deg,#0F3D2E,#1C6B4A)", color: "white", fontWeight: 800, fontSize: 16, cursor: "pointer", boxShadow: "0 12px 28px rgba(15,61,46,0.28)" }}>
            🛍️ Shop local &amp; start saving on insurance
          </button>
        </div>
      </section>
    </div>
  );
}
